import { render, staticRenderFns } from "./WaitingAreaAdd.vue?vue&type=template&id=894a25e8&"
import script from "./WaitingAreaAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingAreaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports